import Svg, { Path } from 'react-native-svg'

export const ContactsIcon = ({ height = 24, width = 24, color = '#141414' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M2.5 5v10A2.5 2.5 0 0 0 5 17.5h.833v-15H5A2.5 2.5 0 0 0 2.5 5ZM15 2.5H7.5v15H15a2.5 2.5 0 0 0 2.5-2.5V5A2.5 2.5 0 0 0 15 2.5Zm-2.5 4.167a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Zm1.667 6.666h-3.334A.834.834 0 0 1 10 12.5a2.5 2.5 0 0 1 5 0 .833.833 0 0 1-.833.833Z"
      />
    </Svg>
  )
}
